import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const MePageTitle = () => {
  const { t } = useTranslation();
  return (
    <Col xs={12} className="pt-5">
      <h1 className="fs-1 d-none d-md-block">{t('header.title')}</h1>
      <h1 className="fs-2 d-md-none">{t('header.title')}</h1>
      <div className="text-gray mb-3"> {t('mePage.headerDescription')}</div>
    </Col>
  );
};

export default MePageTitle;
